<template>
  <nav-bar/>

  <Title content="科学研究"/>
  <img src="~assets/img/research/researchbg.jpg" alt="" style="width: 100%; height: 50vh;">


  <div class="main">
    <p class="title">{{lang === 'zh' ? detail.title : detail.titleEn}}<span>{{showDate}}</span></p>
    <div class="content">
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word1 : detail.word1En}}</p>
      <img :src="showUploadImg + detail.img1" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note1 : detail.note1En}}</p>
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word2 : detail.word2En}}</p>
      <img :src="showUploadImg + detail.img2" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note2 : detail.note2En}}</p>
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word3 : detail.word3En}}</p>
      <img :src="showUploadImg + detail.img3" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note3 : detail.note3En}}</p>
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word4 : detail.word4En}}</p>
      <img :src="showUploadImg + detail.img4" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note4 : detail.note4En}}</p>
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word5 : detail.word5En}}</p>
      <img :src="showUploadImg + detail.img5" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note5 : detail.note5En}}</p>
      <p class="word">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{lang === 'zh' ? detail.word6 : detail.word6En}}</p>
      <img :src="showUploadImg + detail.img6" alt="" class="img">
      <p class="note">{{lang === 'zh' ? detail.note6 : detail.note6En}}</p>
    </div>
  </div>

  <Footer/>

  <Animate ref="animate" />

</template>

<script>

  import NavBar from "@/components/common/NavBar";
  import Title from "@/components/common/Title";
  import Footer from "@/components/common/Footer";
  import Animate from "@/components/common/Animate";

  import {ref, reactive, onMounted, getCurrentInstance} from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore, mapGetters } from 'vuex'
  import bus from 'vue3-eventbus'  //引入事件总线
  import { formatDate } from '@/common/utils'

  export default {
    name: "ResearchDetails",
    components:{
      NavBar,
      Title,
      Footer,
      Animate
    },
    computed: {
      ...mapGetters(['showUploadImg']),
      showDate(){
        return formatDate(new Date(JSON.parse(decodeURIComponent(useRoute().params.obj)).createdTime), 'yyyy-MM-dd')
      },
    },
    setup(){
      let instance = reactive({})
      instance = getCurrentInstance();

      onMounted(() => {
        // JSON.parse(decodeURIComponent(route.params.obj))
        const date = new Date(JSON.parse(decodeURIComponent(route.params.obj)).createdTime)
        //console.log('解码后obj: ', formatDate(date, 'yyyy-MM-dd'))  //不懂就看readme.md

        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })


      const route = useRoute()
      const router = useRouter()

      const store = useStore()
      let lang = ref('')
      lang.value = store.state.language;
      //监听事件总线
      bus.on('changeLang', type => lang.value = type);

      let detail = reactive({})
      detail = JSON.parse(decodeURIComponent(route.params.obj));


      return{ route, detail, lang,

      }
    },
  }
</script>

<style scoped lang="less">

  .main{
    margin: 25px 12.5% 0;
    padding-bottom: 100px;
    .title{
      padding-top: 20px;
      font-size: 18px;
      color: #333;
      line-height: 65px;
      border-bottom: 1px solid #eaeaea;
      span{
        font-size: 12px;
        padding-left: 30px;
      }
    }

    .word{
      margin: 30px 0 20px;
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }

    .img{
      //margin-left: 15%;
      display: block;
      margin: auto;
      max-width: 70%;
      max-height: 300px;
    }

    .note{
      margin-top: 5px;
      text-align: center;
    }




  }

</style>